module.exports = __webpack_public_path__ + "static/media/mid4.6f014740.webm";